import Vue from 'vue';

Vue.component('stock-return-index', () =>
    import(/* webpackChunkName: 'stock-return-index' */ './stock-return-index.vue'),
);



// WEBPACK FOOTER //
// ./resources/assets/js/franchise_component/franchise-inventory/stock-return/index.js